/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiTitle } from '@elastic/eui'

const CreateDeploymentTrustRelationshipHeader: React.FunctionComponent = () => (
  <div className='deploymentTitle-mainTitle'>
    <EuiTitle size='l' className='deploymentTitle' data-test-id='deployment-title'>
      <h2>
        <FormattedMessage
          id='deployment-header.trust.create'
          defaultMessage='Add trusted environment'
        />
      </h2>
    </EuiTitle>
  </div>
)

export default CreateDeploymentTrustRelationshipHeader
